import { FeatureConfiguration } from "..";
import { nativeReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.nativeState = nativeReducer;
}
